import React from "react";

interface ViewerIframeProps {
  url: string;
  caseId: string;
  encryptedAuth: string;
  loadAllSeries: boolean;
}

function ViewerWrapper({
  url,
  caseId,
  encryptedAuth,
  loadAllSeries,
}: ViewerIframeProps) {
  return (
    <iframe
      src={`${url}?caseId=${caseId}&auth=${encryptedAuth}&guest=false&loadAllSeries=${loadAllSeries}`}
      title="Case viewer"
      className="viewer-wrapper__iframe"
    />
  );
}

export default ViewerWrapper;
